import { OFFER } from '../data/checkout'

export const META_PIXEL_ID = '1731716034156669'

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

type FbqWindow = Window & { fbq?: FbqFn; _fbq?: FbqFn }

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  const w = window as FbqWindow

  try {
    if (!w.fbq) {
      const n: FbqFn = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args)
        } else {
          n.queue?.push(args)
        }
      } as FbqFn
      w.fbq = n
      if (!w._fbq) w._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const target = document.head || document.body || document.documentElement
      if (target) target.appendChild(script)

      w.fbq('init', META_PIXEL_ID)
    }
    w.fbq('track', 'PageView')
  } catch {
    /* analytics must never break the page */
  }
}

export function trackCheckout(): void {
  if (typeof window === 'undefined') return
  const fbq = (window as FbqWindow).fbq
  if (!fbq) return
  fbq('track', 'InitiateCheckout', {
    content_name: OFFER.name,
    value: OFFER.price,
    currency: OFFER.currency,
  })
}
